// extracted by mini-css-extract-plugin
export var darkMode = "_c-0";